var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.743 10.331L10.743 0.330996C10.364 -0.0910041 9.63599 -0.0910041 9.25699 0.330996L0.256994 10.331C0.127674 10.4747 0.0427905 10.6528 0.0126187 10.8438C-0.017553 11.0348 0.00828102 11.2304 0.0869934 11.407C0.246993 11.768 0.604993 12 0.999994 12H2.99999V19C2.99999 19.2652 3.10535 19.5196 3.29289 19.7071C3.48042 19.8946 3.73478 20 3.99999 20H6.99999C7.26521 20 7.51956 19.8946 7.7071 19.7071C7.89464 19.5196 7.99999 19.2652 7.99999 19V15H12V19C12 19.2652 12.1054 19.5196 12.2929 19.7071C12.4804 19.8946 12.7348 20 13 20H16C16.2652 20 16.5196 19.8946 16.7071 19.7071C16.8946 19.5196 17 19.2652 17 19V12H19C19.1937 12.0008 19.3834 11.9453 19.546 11.8401C19.7087 11.735 19.8372 11.5848 19.916 11.4079C19.9947 11.231 20.0203 11.0349 19.9896 10.8437C19.9589 10.6525 19.8732 10.4744 19.743 10.331Z",
    fill: "#67748E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardInactive);
export default __webpack_public_path__ + "static/media/Dashboard-Inactive.82eb41753cf2d362d950a2567839e901.svg";
export { ForwardRef as ReactComponent };